import { AppLayout } from "../../../layout/AppLayout";
import { Arrow } from "../../../components/svg/Wallet/Wallet";
import { Card } from "../../../components/Card";
import { useNavigate } from "react-router-dom";
import { BaseInput } from "../../../components/input/baseInput";
import Button from "../../../components/button/Button";
import { FullModal } from "../../world/rmc/modals/fullModal";
import { useState } from "react";
import clsx from "clsx";
import { CustomPinInput } from "../../../components/input/CustomPinInput";
import { Keypad } from "../../../components/keypad";
import { SuccessModal } from "../../../components/modals/SuccessModal";
import { AnimatePresence } from "framer-motion";

export const accountDetails = [
  { label: "Account name", value: "John Doe" },
  { label: "Bank name", value: "Guarantee Trust Bank" },
  { label: "Account number", value: "0000222000" },
];

export const transactionSummary = [
  { label: "Amount", value: "₦5000" },
  { label: "Transaction fee", value: "₦50" },
  { label: "Processing time", value: "24 hours" },
];

export const transaction = {
  reference: "7340345DKQ87322",
  status: "successful",
  time: "15-05-2025, 12:22:07",
  paymentMethod: "Bank Transfer",
  creditedTo: "0000222000",
  bank: "Guarantee Trust Bank",
  amount: "₦5000.00",
};
export const SavedAccount = () => {
  const [show, setShow] = useState(false);
  const [success, setSuccess] = useState(false);
  const [confirmDetails, setConfirmDetails] = useState(false);
  const navigate = useNavigate();
  const [pin, setPin] = useState("");
  const pinLength = 4;
  return (
    <AppLayout noNav bg={"!bg-[#F8F8F8]"}>
      <div className=" min-h-screen px-4 pt-10">
        <div className="relative flex items-center justify-center">
          <Arrow
            onClick={() => navigate(-1)}
            stroke="#fff"
            className="text-lg absolute left-0 cursor-pointer  "
          />
          <p className="font-bold text-xl text-primary-black">Withdraw</p>
        </div>
        <div className="mt-10 flex flex-col gap-5">
          <Card>
            <div className="mb-5">
              <BaseInput
                label="Enter Amount"
                type="number"
                placeholder="500 - 99,999"
                inputClass="bg-[#F8F8F8]"
              />
              <span className="text-[10px] text-[#00000080] font-medium">
                Available Balance: ₦30,000
              </span>
            </div>
            <BaseInput
              label="Description"
              placeholder="What’s this for?(optional)"
              inputClass="bg-[#F8F8F8]"
            />
          </Card>

          <Button
            onClick={() => setShow(true)}
            text="Withdraw Funds"
            className="!py-4 !mt-7 !rounded-[50px] "
          />
        </div>
      </div>
      <AnimatePresence>
        {show && (
          <FullModal
            className={clsx(
              "h-[450px] fixed inset-x-0 bottom-0 z-[4000] bg-[#F8F8F8] animate-slide-up 480:max-w-[440px] 480:mx-auto rounded-t-[20px] overflow-hidden"
            )}
            onClose={() => setShow(false)}
          >
            <div className="py-5 px-10 bg-white flex flex-col">
              <div
                onClick={() => setShow(false)}
                className="bg-[#4B5563] w-[50px] rounded-[5px] h-[6px] grid place-self-center mb-6 cursor-pointer"
              ></div>
              <h2 className="text-base font-medium text-center text-primary-black mb-4">
                Enter Transaction Pin
              </h2>

              <CustomPinInput disabled pin={pin} />
            </div>
            <Keypad
              pinLength={pinLength}
              pin={pin}
              setPin={setPin}
              onPinComplete={() => {
                setConfirmDetails(true);
                setPin("");

                setTimeout(() => {
                  setShow(false);
                }, 200);
              }}
            />
          </FullModal>
        )}
      </AnimatePresence>
      <AnimatePresence>
        {confirmDetails && (
          <FullModal
            className={clsx(
              "h-[576px] fixed inset-x-0 bottom-0 z-[4000] bg-[#F8F8F8] animate-slide-up 480:max-w-[440px] 480:mx-auto rounded-t-[20px] overflow-hidden"
            )}
            onClose={() => setConfirmDetails(false)}
          >
            <div className="pt-5 pb-1 px-5 bg-white flex flex-col">
              {" "}
              <div
                onClick={() => setConfirmDetails(false)}
                className="bg-[#4B5563] w-[50px] rounded-[5px] h-[6px] grid place-self-center mb-6 cursor-pointer"
              ></div>
              <div className="bg-[#F8F8F8] p-4">
                <div className="flex flex-col gap-5 mb-6 text-primary-black">
                  {accountDetails.map((item, index) => (
                    <div key={index}>
                      <p className="text-primary-black text-sm font-normal">
                        {item.label}
                      </p>
                      <p className="text-primary-black text-base font-semibold">
                        {item.value}
                      </p>
                    </div>
                  ))}
                </div>

                <div className="flex gap-3 flex-col items-center">
                  {transactionSummary.map((item, index) => (
                    <div
                      key={index}
                      className="w-full flex justify-between items-center gap-4"
                    >
                      <p className="text-primary-black text-sm font-normal">
                        {item.label}
                      </p>
                      <span className="text-primary-black text-base font-semibold">
                        {item.value}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="mt-10">
                <Button
                  onClick={() => {
                    setSuccess(true);
                    setConfirmDetails(false);
                  }}
                  text="Confirm & Continue"
                  className="!py-4 !rounded-[50px] "
                />
                <Button
                  onClick={() => setConfirmDetails(false)}
                  text="Cancel"
                  className="!py-4 mt-5 !rounded-[50px] button_cancel !text-[#B4B4B4] !shadow-none"
                />
              </div>
            </div>
          </FullModal>
        )}
      </AnimatePresence>
      <AnimatePresence>
        {success && (
          <SuccessModal
            action="Withdrawal"
            transaction={transaction}
            onClick={() => {
              setSuccess(false);
              setTimeout(() => {
                navigate("/settings/wallet");
              }, 200);
            }}
          />
        )}
      </AnimatePresence>
    </AppLayout>
  );
};
